import { render, staticRenderFns } from "./Suivi.vue?vue&type=template&id=4bf7bf89&scoped=true&"
import script from "./Suivi.vue?vue&type=script&lang=js&"
export * from "./Suivi.vue?vue&type=script&lang=js&"
import style0 from "./Suivi.vue?vue&type=style&index=0&id=4bf7bf89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf7bf89",
  null
  
)

export default component.exports